import { createContext } from "react";
import { ScannerInputValue } from "@/interfaces";

export interface AppContextProps {
  searchValue?: ScannerInputValue;
  setSearchValue?: (searchValue?: ScannerInputValue) => void;
  isOffsite?: boolean;
  setIsOffsite?: (isOffsite: boolean) => void;
}

export const AppContext = createContext<AppContextProps>({
  searchValue: undefined,
  setSearchValue: undefined,
  isOffsite: undefined,
  setIsOffsite: undefined,
});
